import escapeHtml from 'escape-html';
import { Descendant, Text } from 'slate';

/**
 * Converts a Slate.js document into a Html string Note that the structure of
 * the Html is limited by what we allow.
 */
export function serializeToHtml(nodes: Descendant[] | undefined): string {
  if (!nodes) return '';
  return nodes.map(serializeNode).join('');
}

/**
 * Serialise a single slate.js node into Html string
 *
 * @param node Slate node
 * @returns Html string
 */
function serializeNode(node: Descendant): string {
  if (Text.isText(node)) {
    let string = escapeHtml(node.text);
    if (node.bold) string = `<strong>${string}</strong>`;
    if (node.italic) string = `<em>${string}</em>`;
    if (node.underline) string = `<u>${string}</u>`;
    return string;
  }

  const children = node.children.map((n) => serializeNode(n)).join('');

  switch (node.type) {
    case 'heading-two':
      return `<h2>${children}</h2>`;
    case 'paragraph': {
      if (!children) return '';
      return `<p>${children}</p>`;
    }
    case 'image':
      return `<img src="${escapeHtml(node.src)}">${children}</img>`;
    case 'link':
      return `<a href="${escapeHtml(
        node.href,
      )}" target="_blank" rel="noopener noreferrer">${children}</a>`;
    default:
      assertUnreachableNode(node);
  }
  // Just to quiet ESLint, not used though
  return '';
}

function assertUnreachableNode(element: never): never {
  const msg = `${element} is not handled in serializeNode`;
  console.warn(msg);
  throw new Error(msg);
}
